import React, { useEffect } from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Typography,
} from "@material-tailwind/react";
import { FormProvider, useForm } from "react-hook-form";
import { fetcherFull } from "utils/api";
import RHFInput from "../form/rhf-input";
import { toast } from "react-toastify";

export default function ConfirmReportAdminDialog(props) {
    const methods = useForm({
        mode: "onChange",
        defaultValues: { admin_comment: "" },
    });
    const { reset } = methods;

    // Reset once per open transition so comments cannot bleed between
    // moderated answers. confirmingAnswer is not a dep: callers swap it
    // while the dialog is closed, so the open transition already covers
    // every change.
    useEffect(() => {
        if (props.showDialog) {
            reset({ admin_comment: "" });
        }
    }, [props.showDialog, reset]);

    const handle = () => {
        const showDialogProp = props.showDialog;
        props.setShowConfirmReportDialog((showDialogProp) => !showDialogProp);
    };

    const reportSubmit = async (values) => {
        const response = await fetcherFull(
            `/v2/response/question/${props.question.nanoid}/answer/${props.confirmingAnswer.nanoid}/admin_abuse`,
            "POST",
            { admin_comment: values.admin_comment },
        );
        console.log(response);
        if (response && response?.status === "reported") {
            toast.success("Answer Reported");
            props.surveyAbuseMutate();
        } else {
            toast.error("Error Reporting Answer");
        }
        handle();
    };

    return (
        <>
            <Dialog
                open={props.showDialog}
                handler={handle}
                className="dialog"
            >
                <FormProvider {...methods}>
                    <form onSubmit={methods.handleSubmit(reportSubmit)}>
                        <DialogHeader className="dialog__header">
                            Report an Answer
                        </DialogHeader>
                        <DialogBody className="dialog__body">
                            <Typography className="font-body my-2 text-center">
                                Add a comment to the reported answer for added
                                context.
                            </Typography>
                            <RHFInput
                                className="p-2 font-body text-black"
                                type="text"
                                variant="static"
                                size="md"
                                name="admin_comment"
                                placeholder="Enter your comment here!"
                            />
                        </DialogBody>
                        <DialogFooter className="dialog__footer">
                            <Button
                                type="submit"
                                className="btn btn--primary"
                                variant="filled"
                            >
                                Report
                            </Button>
                            <Button
                                type="button"
                                className="btn btn--secondary ml-2"
                                variant="filled"
                                onClick={() => handle()}
                            >
                                Cancel
                            </Button>
                        </DialogFooter>
                    </form>
                </FormProvider>
            </Dialog>
        </>
    );
}
